/* global window, document, URL, Blob */
import angular from 'angular';
import * as R from 'ramda';
import constants from 'app/constants';
import { alerts } from 'app/components/global';
import IComplianceAppDataService from './IComplianceApp.data.service';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

let _alerts;

class oversightDataService extends IComplianceAppDataService {
  constructor(
    $http,

    alerts, // eslint-disable-line no-shadow
    utilityService // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'over', { settings: 'settings' });
    _alerts = alerts;
    console.log('app.services.oversightDataService created');
  }

  // ///////////// oversight ///////////////////
  initOversight() {
    return this.$http({
      url: `${this.apiRootUrl}/oversight/initOversight`,
      method: 'GET',
      params: {}
    });
  }

  // ///////////// Agenda ///////////////////
  getAgendas() {
    return this.$http({
      url: `${this.apiRootUrl}/agenda`,
      method: 'GET',
      params: {}
    });
  }

  // getAgendaItemsByCategory(categoryId) {
  //   return this.$http({
  //     url: `${this.apiRootUrl}/am/audit/${auditId}`,
  //     method: 'GET',
  //     params: {}
  //   });
  // }

  getBaseAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/base/`,
      method: 'GET',
      params: {}
    });
  }

  getAgenda(agendaId) {
    return this.$http({
      url: `${this.apiRootUrl}/agenda/${agendaId}/`,
      method: 'GET',
      params: {}
    });
  }

  getAgendaTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/agendaType`,
      method: 'GET',
      params: {}
    });
  }

  checkAgendaExists(name, agendaId) {
    return this.$http({
      url: `${this.apiRootUrl}/agenda/checkExists/`,
      method: 'GET',
      params: {
        id: agendaId,
        name
      }
    });
  }

  saveAgenda(agenda) {
    const a = {
      agendaId: agenda.agendaId,
      customerId: agenda.customerId,
      agendaTemplateId: agenda.agendaTemplateId,
      agendaTypeId: agenda.agendaTypeId,
      coordinatorUserId: agenda.coordinatorUserId,
      coordinatorName: agenda.coordinatorName,
      name: agenda.name,
      isActive: agenda.isActive,
      startDate: agenda.startDate,
      endDate: agenda.endDate,
      defaultDueDate: agenda.defaultDueDate,
      createdDate: agenda.createdDate,
      createdUserId: agenda.createdUserId,
      notes: agenda.notes,
      completionSummary: agenda.completionSummary,
    };

    if (a.agendaId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/agenda/${a.agendaId}`,
        method: 'PUT',
        data: JSON.stringify(a),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/Json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/agenda`,
      method: 'POST',
      data: JSON.stringify(a),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteAgenda(agendaId) {
    return this.$http({
      url: `${this.apiRootUrl}/agenda/${agendaId}`,
      method: 'DELETE',
      params: {}
    });
  }

  completeCheckpoint(agendaId) {
    return this.$http({
      url: `${this.apiRootUrl}/agenda/${agendaId}/completeCheckpoint`,
      method: 'PUT',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  // ///////////// Agenda Item ////////////////////

  completeAgendaItem(agendaId, item) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaId}/complete`,
      method: 'PUT',
      data: JSON.stringify(item),
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  hasIncompleteAudit(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit`,
      method: 'GET',
      params: {
        action: 'hasIncompleteAudit',
        customerId
      }
    });
  }

  getAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}`,
      method: 'GET',
    });
  }


  updateAgendaItem(agendaItem) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItem.agendaItemId}`,
      method: 'PUT',
      data: this.serializeData(agendaItem),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  markAgendaItemChecked(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}/checked`,
      method: 'PUT',
      data: {},
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // ///////////// Agenda Categories ////////////////////
  getAgendaCategoriesByAgenda(agendaId) {
    return this.$http({
      url: `${this.apiRootUrl}/agenda/${agendaId}/agendaCategory`,
      method: 'GET',
      params: {}
    });
  }

  getAgendaCategoryItems(agendaCategoryId, _includeSubItems) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaCategory/${agendaCategoryId}/agendaItems`,
      method: 'GET',
      params: {
        includeSubItems: _includeSubItems
      }
    });
  }

  getAgendaCategorySubItems(itemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${itemId}`,
      method: 'GET',
      params: {}
    });
  }

  // ///////////// Agenda Item Followup ////////////////////
  saveAgendaItemFollowup(agendaItemId, followupItemId, text) {
    if (followupItemId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/followupItem/${followupItemId}`,
        method: 'PUT',
        data: this.serializeData({
          agendaItemId,
          text: JSON.stringify(text),
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/followupItem`,
      method: 'POST',
      data: this.serializeData({
        agendaItemId,
        followupItemId,
        text: JSON.stringify(text),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getFollowupByAgendItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}/agendaItemComment`,
      method: 'GET',
      params: {}
    });
  }

  deleteAgendaItemFollowup(followupItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/followupItem/${followupItemId}`,
      method: 'DELETE',
      params: {}
    });
  }

  discussAgendaItemFollowup(followupItemId, item) {
    return this.$http({
      url: `${this.apiRootUrl}/followupItem/${followupItemId}`,
      method: 'PUT',
      data: JSON.stringify(item),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  completeAgendaItemFollowup(followupItemId, item) {
    return this.$http({
      url: `${this.apiRootUrl}/followupItem/${followupItemId}/complete`,
      method: 'PUT',
      data: JSON.stringify(item),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  // ///////////// Agenda Items Notes ///////////////////

  saveAgendaItemComments(agendaItemId, agendaItemCommentId, text) {
    if (agendaItemCommentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/agendaItemComment/${agendaItemCommentId}`,
        method: 'PUT',
        data: this.serializeData({
          agendaItemId,
          text: JSON.stringify(text),
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemComment`,
      method: 'POST',
      data: this.serializeData({
        agendaItemId,
        agendaItemCommentId,
        text: JSON.stringify(text),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getCommentsByAgendItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}/agendaItemComment`,
      method: 'GET',
      params: {}
    });
  }

  deleteAgendaItemComment(agendaItemCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemComment/${agendaItemCommentId}`,
      method: 'DELETE',
      params: {}
    });
  }

  // ///////////// Agenda Item Folders ////////////////////
  getAgendaItemFolder(agendaItemFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemFolder/${agendaItemFolderId}`,
      method: 'GET',
      params: {}
    });
  }

  getAgendaItemFoldersByFolder(folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemFolder/byFolder`,
      method: 'GET',
      params: {
        folderId
      }
    });
  }

  getAgendaItemFoldersByAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}/agendaItemFolder`,
      method: 'GET',
      params: {}
    });
  }

  attachAgendaItemFolder(agendaItemId, folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemFolder`,
      method: 'POST',
      data: this.serializeData({
        agendaItemId,
        folderId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAgendaItemFolder(agendaItemFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemFolder/${agendaItemFolderId}`,
      method: 'DELETE',
      params: {}
    });
  }

  // ///////////// Agenda Item Documents ////////////////////
  getAgendaItemDocument(agendaItemDocumentId) {
    console.log('getAgendaItemDocument');
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument/${agendaItemDocumentId}`,
      method: 'GET',
      params: {}
    });
  }

  getAgendaItemDocumentsByFolder(folderId) {
    console.log('getAgendaItemDocumentsByFolder');
    return this.$http({
      url: `${this.apiRootUrl}/folder/${folderId}/agendaItemDocument`,
      method: 'GET',
      params: {}
    });
  }

  getAgendaItemDocumentsByAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}/agendaItemDocument/`,
      method: 'GET',
      params: {}
    });
  }

  attachAgendaItemDocument(agendaItemId, documentId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemDocument`,
      method: 'POST',
      data: this.serializeData({
        agendaItemId,
        documentId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAgendaItemDocument(agendaItemDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemDocument/${agendaItemDocumentId}`,
      method: 'DELETE',
      params: {}
    });
  }

  // ///////////// Agenda Item Reports ////////////////////
  getAgendaItemReport(agendaItemReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingReport/${agendaItemReportInstanceId}`,
      method: 'GET',
      params: {}
    });
  }

  getAgendaItemReportsByAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItem/${agendaItemId}/agendaItemReport`,
      method: 'GET',
      params: {}
    });
  }

  attachAgendaItemReport(agendaItemId, reportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemReport`,
      method: 'POST',
      data: this.serializeData({
        agendaItemId,
        reportInstanceId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAgendaItemReport(agendaItemReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/agendaItemReport/${agendaItemReportInstanceId}`,
      method: 'DELETE',
      params: {}
    });
  }

  // ///////////// Agenda Package ///////////////////

  createAgendaPackageFileGenerationRequest(agendaId) {
    return this.$http.post(`${this.apiRootUrl}/agenda/${agendaId}/generateAgendaPackage`, {}, {});
  }

  // ///// General General Download Package //////////
  downloadPackage(agendaPackageId) {
    const url = `${this.apiRootUrl}/agendaPackage/${agendaPackageId}/download`;
    return this.$http({
      url,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  download(response) {
    const contentType = response.headers('Content-Type');
    const contentDisposition = response.headers('Content-Disposition');
    let fileName = '';

    if (!R.isNil(contentDisposition)) {
      // const matches = /filename="(.*?)"/g.exec(contentDisposition);
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      fileName = matches && matches.length > 1 ? matches[1] : null;
      fileName = fileName.split('"').join('');
    }

    const blob = new Blob(
      [response.data],
      { type: contentType, }
    );
    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = fileName;
      anchor.target = '_self';
      anchor.click();
    }
  }
  // ///////////// Reports ///////////////////

  getReports() {
    return this.$http({
      url: `${this.apiRootUrl}/am/amReport`,
      method: 'GET',
      params: {
        action: 'getList',
      }
    });
  }

  archiveReport(reportId, parameters) {
    return this.$http.post(`${this.apiRootUrl}/am/Reports/archiveReport`, {}, {
      params: {
        reportId,
        parameters: JSON.stringify(parameters)
      }
    });
  }

  // ///// General Import //////////
  // getImportTemplateFile(networkPath, storeRootKey, fileType, fileName) {
  getImportTemplateFile(auditId, networkPath) {
    const url = `${this.apiRootUrl}/am/${networkPath}/Import/handleImportFile.ashx`;

    const $frmDownloadFile = angular.element(
      '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo(angular.element('#ifrmDownloadFile'));
    $frmDownloadFile.attr('action', url);
    $frmDownloadFile.append(angular.element('<input type="hidden" name="auditId" />').val(auditId));
    $frmDownloadFile.submit();
    _alerts.success(copy.amReports.alerts.downloadTemplate.text);
  }
}

oversightDataService.$inject = [
  '$http',

  'alerts',
  'utilityService'
];

export default angular.module('app.services.oversightDataService', [
  constants,
  alerts,
])
  .service('oversightDataService', oversightDataService)
  .name;
